import {useEffect, useState} from 'react';
import {useDispatcher} from '@netx/core-components/hooks/useDispatcher';
import {AssetVersionEvent} from '../actions/constants';

export type UseAssetVersionArguments = {
	assetId?: number;
};

// TODO: still needs cleanup but it works!
// TODO: need to keep track of any items globally
// we can use the global success/error calls to add/remove
// that way when a asset renders is can pick up here
export const useAssetVersionProgress = ({
	assetId,
}: UseAssetVersionArguments) => {
	const [isSaving, setIsSaving] = useState(false);
	const [progress, setProgress] = useState(0);

	const [cacheBuster, setCachBuster] = useState<{assetVersion: number}>();

	useEffect(() => {
		setIsSaving(false);
		setProgress(0);
	}, [assetId]);

	useDispatcher(`${AssetVersionEvent.UPLOAD}:${assetId}:error`, () => {
		setIsSaving(false);
	});

	useDispatcher(
		`${AssetVersionEvent.UPLOAD}:${assetId}:progress`,
		(progress: number) => {
			setIsSaving(true);
			setProgress(progress);
		},
	);

	useDispatcher(`${AssetVersionEvent.UPLOAD}:${assetId}:succeeded`, () => {
		setProgress(100);
		setTimeout(() => {
			setIsSaving(false);
			setCachBuster({assetVersion: Date.now()});
			setTimeout(() => {
				setProgress(0);
			}, 200);
		}, 200);
	});

	return {
		cacheBuster,
		isSaving,
		isWorking: isSaving,
		progress,
	};
};
